<template>
  <div>
    <usernav></usernav>
    <el-col v-if="loading" class="C-PageLoading">
      <div class="Spinner spinner-grow text-primary"></div>
    </el-col>
    <div v-if="!loading">
    <el-col :xs="24" :sm="12" :md="12" :lg="12">
      <el-card :body-style="{padding: '16px',textAlign: 'left'}" shadow="hover">
        <div class="G-title">我的信息</div>
        <div class="m2">
          钱包余额：{{wallet}}
        </div>
        <div class="m2">
          佣金比例：{{profit}}
        </div>
        <div class="m2">
          推广链接：<span style="color: #f39;cursor:pointer" v-clipboard:copy="link" v-clipboard:success="onCopy" v-clipboard:error="onError">{{link}}</span>
        </div>
        <el-popconfirm title="确定要提现全部金额吗？" @confirm="post_withdraw">
          <el-button size="mini"  slot="reference">
            <svg-icon icon-class="money" style="fill:#f39"></svg-icon> 申请提现</el-button>
        </el-popconfirm>
      </el-card>
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="12">
      <el-card shadow="hover" :body-style="{padding: '19px',textAlign: 'left'}">
        <div class="G-title">
          <span>佣金提现</span>
          <svg-icon icon-class="wait" style="fill:#f39"></svg-icon>
        </div>
        <div class="big-font">
          {{wait_withdraw}}
        </div>
        <div class="text">
          <p>本月佣金提现</p>
          <p>{{month_withdraw}}</p>
        </div>
        <div class="text">
          <p>总计佣金提现</p>
          <p>{{sum_withdraw}}</p>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="12">
      <el-card shadow="hover" :body-style="{padding: '19px',textAlign: 'left'}">
        <div class="G-title">
          <span>新增用户</span>
          <svg-icon icon-class="today" style="fill:#f39"></svg-icon>
        </div>
        <div class="big-font">
          {{user}}
        </div>
        <div class="text">
          <p>本月用户</p>
          <p>{{month_user}}</p>
        </div>
        <div class="text">
          <p>总计用户</p>
          <p>{{sum_user}}</p>
        </div>
      </el-card>
    </el-col>
    <el-col :xs="24" :sm="12" :md="12" :lg="12">
      <el-card shadow="hover" :body-style="{padding: '19px',textAlign: 'left'}">
        <div class="G-title">
          <span>所得佣金</span>
          <svg-icon icon-class="today" style="fill:#f39"></svg-icon>
        </div>
        <div class="big-font">
          {{today_money}}
        </div>
        <div class="text">
          <p>本月佣金</p>
          <p>{{month_money}}</p>
        </div>
        <div class="text">
          <p>总计佣金</p>
          <p>{{sum_money}}</p>
        </div>
      </el-card>
    </el-col>
    <el-col>
      <el-card shadow="never">
        <el-table
          :row-class-name="tableRowClassName"
          :data="tableData"
          style="margin: auto;"
          border
        >
          <el-table-column
            prop="type"
            label="类型"
            >
          </el-table-column>
          <el-table-column
            prop="plus_minus"
            label="金额"
          >
          </el-table-column>
          <el-table-column
            prop="content"
            label="详情"
            v-if="show"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="日期"
            v-if="show"
          >
          </el-table-column>
        </el-table>
      </el-card>
      <el-card shadow="never" :body-style="{margin: '20px'}" style="margin:0">
        <el-pagination
          :small=true
          @current-change="handleCurrentChange"
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="24"
          :pager-count="5">
        </el-pagination>
      </el-card>
    </el-col>
    </div>
  </div>
</template>

<script>
import Usernav from '@/components/base/header/usernav'
import {request} from '../../network/request'
export default {
  name: 'proxy',
  components: {Usernav},
  mounted () {
    if (this.screenWidth <= 991) {
      this.show = false
    } else {
      this.show = true
    }
    window.onresize = () => {
      return (() => {
        window.screenWidth = window.innerWidth
        this.screenWidth = window.screenWidth
      })()
    }
  },
  watch: {
    screenWidth (val) {
      this.screenWidth = val
      if (this.screenWidth <= 991) {
        this.show = false
      } else {
        this.show = true
      }
    }
  },
  data () {
    return {
      loading: true,
      screenWidth: window.innerWidth,
      show: true,
      tableData: [],
      page: 1,
      total: 0,
      // 用户详情资料
      wallet: '',
      profit: '',
      link: '',
      // 提现卡片
      wait_withdraw: '',
      month_withdraw: '',
      sum_withdraw: '',
      // 注册用户卡片
      user: '',
      month_user: '',
      sum_user: '',
      // 所获佣金卡片
      today_money: '',
      month_money: '',
      sum_money: ''
    }
  },
  created () {
    this.get_proxy()
  },
  methods: {
    handleCurrentChange (val) {
      this.page = val
      this.get_proxy()
    },
    get_proxy () {
      let data = new URLSearchParams()
      data.append('page', this.page)
      request({
        url: '/api/proxy',
        method: 'get',
        params: data
      }).then(res => {
        this.wallet = res.data.wallet
        this.profit = res.data.profit + '0%'
        this.link = res.data.link
        this.wait_withdraw = res.data.wait_withdraw
        this.month_withdraw = res.data.month_withdraw
        this.sum_withdraw = res.data.sum_withdraw
        this.user = res.data.user
        this.month_user = res.data.month_user
        this.sum_user = res.data.sum_user
        this.today_money = res.data.today_money
        this.month_money = res.data.month_money
        this.sum_money = res.data.sum_money
        this.tableData = res.data.data
        this.total = res.data.count
        this.loading = false
      }).catch(err => {
        console.log(err)
      })
    },
    post_withdraw () {
      if (this.wallet >= 100) {
        let data = new URLSearchParams()
        data.append('wallet', this.wallet)
        request({
          url: '/api/proxy',
          method: 'post',
          data: data
        }).then(res => {
          if (res.data.status === 0) {
            this.$message.success('提现成功')
            this.get_proxy()
          } else {
            this.$message.error('提现失败')
          }
        }).catch(err => {
          console.log(err)
        })
      } else {
        this.$message.error('满100可提现')
      }
    },
    tableRowClassName ({row, rowIndex}) {
      if (row.type === '分成') {
        return 'success-row'
      } else {
        return 'warning-row'
      }
    },
    onCopy () {
      this.$message.success('复制成功')
    },
    onError () {
      this.$message.console.error('复制失败')
    }
  }
}
</script>

<style scoped>
  .el-card {
    /* margin-bottom: .5rem!important; */
    margin-top: 0px;
  }
  .G-title {
    border-bottom: 1px solid #f2f2f2 !important;
    padding-bottom: 10px;
    justify-content: space-between !important;
    display: flex !important;
  }
  .text{
    font-size: 14px;
    justify-content: space-between !important;
    display: flex !important;
  }
  .big-font {
    font-size: 36px;
    color: #666;
    line-height: 36px;
    padding: 10px 0 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
  }
  .svg-icon {
    width: 1.2em;
    height: 1.2em;
    vertical-align: -0.2em;
    fill: currentColor;
  }
  .m2 {
    margin-bottom: .5rem;
    margin-top: .5rem;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/proxy.vue